import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { DashboardsDisplayGridRowDataFragment, DashboardSortOrder, LensDownstreamDashboardsQuery, LensDownstreamDashboardsQueryVariables , LensDownstreamDashboardsDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import { DashboardsDisplayGrid, DashboardsDisplayGridRowData, getRowDataForDashboard } from '../sharedDisplayGrid/DashboardsDisplayGrid';
import { DashboardsValidSortFields } from '../sorting/sortProviders/DashboardsGridSortProvider';

type QueryVariables = LensDownstreamDashboardsQueryVariables;
type QueryResults = LensDownstreamDashboardsQuery;
type QueryResultListNode = DashboardsDisplayGridRowDataFragment;
type GridRowData = DashboardsDisplayGridRowData;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.lenses && resultData.lenses[0]?.downstreamDashboardsConnection;
}

export type LensDownstreamDashboardsQueryGridProps =
  GridSortProps<DashboardsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

export function LensDownstreamDashboardsQueryGrid(props: LensDownstreamDashboardsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamDashboardsLineageGridMessage();

  return <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
    queryGql={LensDownstreamDashboardsDocument}
    partialQueryVariables={{ vizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy as DashboardSortOrder }}
    selectConnectionListResult={selectConnectionListResult}
    mapResultNode={getRowDataForDashboard}
  >
    {({ rowStore }) => <DashboardsDisplayGrid
      rowStore={rowStore}
      emptyGridMessage={emptyGridMessage}
      rowCount={props.rowCount}
      orderBy={props.orderBy}
      updateSortOrder={props.updateSortOrder}
    />}
  </PaginatedQueryWrapper>;
}
